import { useMemo } from "react";
import { useLedgerCardSettings } from "services/ledgerCardSettingsService";
import { parsePostingStyle } from "pages/Settings/LedgerCardSettings/styleUtils";

export const usePostingStyle = () => {
  const { data: ledgerCardSettings, loading } = useLedgerCardSettings();

  const postingStyleMap = useMemo(() => {
    if (!ledgerCardSettings?.length) return {};
    return Object.fromEntries(
      ledgerCardSettings
        .filter((s) => s.postingType && s.style)
        .map((s) => [s.postingType, parsePostingStyle(s.style)])
    );
  }, [ledgerCardSettings]);

  return { postingStyleMap, loading };
};
